module.exports = __webpack_public_path__ + "static/media/GongXiang4.e565757c.png";